import API from "../../services/api";

function detail(error, fallback) {
  const body = error?.response?.data?.detail;
  if (typeof body === "string") return body;
  if (Array.isArray(body)) return body.map((item) => item?.msg || String(item)).join(" ");
  return error?.message || fallback;
}

export async function fetchEncashmentSettings() {
  try {
    const { data } = await API.get("/leave/encashment/settings");
    return data;
  } catch (error) {
    throw new Error(detail(error, "Could not load leave encashment settings."));
  }
}

export async function saveEncashmentSettings(payload) {
  try {
    const { data } = await API.put("/leave/encashment/settings", payload);
    return data;
  } catch (error) {
    throw new Error(detail(error, "Could not save leave encashment settings."));
  }
}

export async function fetchEncashmentContext(employeeId) {
  try {
    const { data } = await API.get("/leave/encashment/context", {
      params: employeeId ? { employee_id: employeeId } : undefined,
    });
    return data;
  } catch (error) {
    throw new Error(detail(error, "Could not load leave encashment."));
  }
}

export async function quoteEncashment(days, employeeId) {
  try {
    const { data } = await API.post("/leave/encashment/quote", {
      days,
      employee_id: employeeId || undefined,
    });
    return data;
  } catch (error) {
    throw new Error(detail(error, "Could not calculate the encashment amount."));
  }
}

export async function submitEncashment(days, employeeId) {
  try {
    const { data } = await API.post("/leave/encashment/requests", {
      days,
      employee_id: employeeId || undefined,
    });
    return data;
  } catch (error) {
    throw new Error(detail(error, "Could not submit the encashment request."));
  }
}

export async function fetchEncashmentRequests(params) {
  try {
    const { data } = await API.get("/leave/encashment/requests", { params });
    return data;
  } catch (error) {
    throw new Error(detail(error, "Could not load encashment history."));
  }
}

export async function decideEncashment(id, payload) {
  try {
    const { data } = await API.post(`/leave/encashment/requests/${id}/decision`, payload);
    return data;
  } catch (error) {
    throw new Error(detail(error, "Could not record the decision."));
  }
}

export async function cancelEncashment(id) {
  try {
    const { data } = await API.post(`/leave/encashment/requests/${id}/cancel`);
    return data;
  } catch (error) {
    throw new Error(detail(error, "Could not cancel the request."));
  }
}

export async function retryEncashmentPayroll(id) {
  try {
    const { data } = await API.post(`/leave/encashment/requests/${id}/payroll`);
    return data;
  } catch (error) {
    throw new Error(detail(error, "Could not post this encashment to payroll."));
  }
}

export async function runYearEndEncashment() {
  try {
    const { data } = await API.post("/leave/encashment/year-end/run");
    return data;
  } catch (error) {
    throw new Error(detail(error, "Year-end encashment did not run."));
  }
}
